import React from 'react'
import { Layout, Box } from 'pcln-design-system'
import { AppDownload } from '@pcln/vip'
import analytics from '@/shared-utils/analytics'

type AppDownloadWrapperProps = {
  category: string
  isUsingNewLayout?: boolean
}

const AppDownloadWrapper = ({
  category,
  isUsingNewLayout = false,
  ...props
}: AppDownloadWrapperProps & Record<string, unknown>) => {
  const gaAppDownload = (device: string) => {
    analytics.fireEvent({
      action: 'app download',
      category,
      label: device
    })
  }

  return isUsingNewLayout ? (
    <Layout variation="100" rowGap="xl">
      <Box
        color="background.light"
        boxShadowSize="sm"
        borderRadius="xl"
        pr={[3, null, null, null, 4, 5]}
        pl={4}
      >
        <AppDownload gaTracking={gaAppDownload} {...props} />
      </Box>
    </Layout>
  ) : (
    <AppDownload gaTracking={gaAppDownload} {...props} />
  )
}

export default AppDownloadWrapper
